// 按需引入
import {
  Pagination, //分页
  Dialog, //对话框
  Dropdown, //下拉菜单
  Divider, //分割线
  Image, //图片
  Drawer, //抽屉
  Empty, //空状态
  Form, //表单
  Input, //输入框
  InputNumber, //计数器
  Checkbox, //多选框
  Button, //按钮
  Select, //选择器
} from 'element-ui';


export default {
  components: [
    Pagination, Dialog, Dropdown, Divider, Image, Drawer, Empty,Form,Input,InputNumber,Checkbox,Button,Select
  ]
}


// WEBPACK FOOTER //
// ./src/plugins/element.js